import React, { useEffect, useState } from 'react';
import { MapPin } from 'lucide-react';
const purchases = [{
  name: 'Martín S.',
  city: 'Córdoba'
}, {
  name: 'Diego L.',
  city: 'Rosario'
}, {
  name: 'Julieta M.',
  city: 'CABA'
}, {
  name: 'Facundo R.',
  city: 'Mendoza'
}, {
  name: 'Lucas G.',
  city: 'La Plata'
}, {
  name: 'Tomás V.',
  city: 'Mar del Plata'
}, {
  name: 'Agustín P.',
  city: 'Tucumán'
}];
export function PopupNotification() {
  const [visible, setVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const showPopup = () => {
      const randomPurchase = purchases[Math.floor(Math.random() * purchases.length)];
      setCurrentPurchase(randomPurchase);
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
      }, 4000);
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 5000);
    // Recurring interval
    const interval = setInterval(() => {
      showPopup();
    }, 15000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-80 bg-white rounded-lg shadow-2xl p-3 flex items-center gap-3 z-50 animate-in slide-in-from-bottom-5 fade-in duration-300 border-l-4 border-tennis-green" data-id="element-102">
      <div className="bg-tennis-green/10 p-2 rounded-full" data-id="element-103">
        <MapPin className="w-5 h-5 text-tennis-green" data-id="element-104" />
      </div>
      <div data-id="element-105">
        <p className="text-sm font-semibold text-gray-800" data-id="element-106">
          {currentPurchase.name} acaba de comprar
        </p>
        <p className="text-xs text-gray-500" data-id="element-107">
          desde {currentPurchase.city}, Argentina
        </p>
      </div>
    </div>;
}